// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file chat/chat_errors.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file chat/chat_errors.proto.
 */
export const file_chat_chat_errors: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChZjaGF0L2NoYXRfZXJyb3JzLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCLrAwoJQ2hhdEVycm9yGhMKEUNoYXRJc1VuYXZhaWxhYmxlGhIKEENoYXREb2VzTm90RXhpc3QaDQoLQ2hhdEJhZERhdGEaEQoPRGVlcExpbmtCYWREYXRhGg8KDURlZXBMaW5rVGFrZW4aEgoQVXNlckRvZXNOb3RFeGlzdBoOCgxXcm9uZ1AyUENoYXQaEQoPSW52YWxpZENoYXRUeXBlGiEKH0hhc05vUGVybWlzc2lvbnNUb1BlcmZvcm1BY3Rpb24aIgogVXNlckNoYXRSZWxhdGlvbnNoaXBEb2VzTm90RXhpc3QaFQoTVW5zdXBwb3J0ZWRDaGF0VHlwZRoTChFQaW5uZWRHcm91cHNMaW1pdBoVChNQaW5uZWRDaGFubmVsc0xpbWl0Gh4KHE5vUGVybWlzc2lvbnNUb0RlbGV0ZU1lc3NhZ2UaHAoaTm9QZXJtaXNzaW9uc1RvU2VuZE1lc3NhZ2UaFQoTTWVzc2FnZURvZXNOb3RFeGlzdBoVChNBcnRpY2xlSXNOb3RBbGxvd2VkGhgKFkUyZWVDb21taXRTeW5jUmVxdWlyZWQaGgoYRTJlZUNvbW1pdFJlc3luY1JlcXVpcmVkGh8KHUUyZWVQYXJ0aWNpcGFudE1pc3NpbmdXZWxjb21lQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw'
  );

/**
 * @generated from message com.gem.bff.contract.ChatError
 */
export type ChatError = Message<'com.gem.bff.contract.ChatError'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.
 * Use `create(ChatErrorSchema)` to create a new message.
 */
export const ChatErrorSchema: GenMessage<ChatError> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0);

/**
 * E_CHAT_IS_UNAVAILABLE
 *
 * @generated from message com.gem.bff.contract.ChatError.ChatIsUnavailable
 */
export type ChatError_ChatIsUnavailable =
  Message<'com.gem.bff.contract.ChatError.ChatIsUnavailable'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.ChatIsUnavailable.
 * Use `create(ChatError_ChatIsUnavailableSchema)` to create a new message.
 */
export const ChatError_ChatIsUnavailableSchema: GenMessage<ChatError_ChatIsUnavailable> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 0);

/**
 * E_CHAT_DOES_NOT_EXIST
 *
 * @generated from message com.gem.bff.contract.ChatError.ChatDoesNotExist
 */
export type ChatError_ChatDoesNotExist =
  Message<'com.gem.bff.contract.ChatError.ChatDoesNotExist'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.ChatDoesNotExist.
 * Use `create(ChatError_ChatDoesNotExistSchema)` to create a new message.
 */
export const ChatError_ChatDoesNotExistSchema: GenMessage<ChatError_ChatDoesNotExist> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 1);

/**
 * E_CHAT_BAD_DATA
 *
 * @generated from message com.gem.bff.contract.ChatError.ChatBadData
 */
export type ChatError_ChatBadData = Message<'com.gem.bff.contract.ChatError.ChatBadData'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.ChatBadData.
 * Use `create(ChatError_ChatBadDataSchema)` to create a new message.
 */
export const ChatError_ChatBadDataSchema: GenMessage<ChatError_ChatBadData> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 2);

/**
 * E_DEEP_LINK_BAD_DATA
 *
 * @generated from message com.gem.bff.contract.ChatError.DeepLinkBadData
 */
export type ChatError_DeepLinkBadData =
  Message<'com.gem.bff.contract.ChatError.DeepLinkBadData'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.DeepLinkBadData.
 * Use `create(ChatError_DeepLinkBadDataSchema)` to create a new message.
 */
export const ChatError_DeepLinkBadDataSchema: GenMessage<ChatError_DeepLinkBadData> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 3);

/**
 * E_DEEP_LINK_TAKEN
 *
 * @generated from message com.gem.bff.contract.ChatError.DeepLinkTaken
 */
export type ChatError_DeepLinkTaken = Message<'com.gem.bff.contract.ChatError.DeepLinkTaken'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.DeepLinkTaken.
 * Use `create(ChatError_DeepLinkTakenSchema)` to create a new message.
 */
export const ChatError_DeepLinkTakenSchema: GenMessage<ChatError_DeepLinkTaken> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 4);

/**
 * E_USER_DOES_NOT_EXIST
 *
 * @generated from message com.gem.bff.contract.ChatError.UserDoesNotExist
 */
export type ChatError_UserDoesNotExist =
  Message<'com.gem.bff.contract.ChatError.UserDoesNotExist'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.UserDoesNotExist.
 * Use `create(ChatError_UserDoesNotExistSchema)` to create a new message.
 */
export const ChatError_UserDoesNotExistSchema: GenMessage<ChatError_UserDoesNotExist> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 5);

/**
 * E_WRONG_P2P_CHAT
 *
 * @generated from message com.gem.bff.contract.ChatError.WrongP2PChat
 */
export type ChatError_WrongP2PChat = Message<'com.gem.bff.contract.ChatError.WrongP2PChat'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.WrongP2PChat.
 * Use `create(ChatError_WrongP2PChatSchema)` to create a new message.
 */
export const ChatError_WrongP2PChatSchema: GenMessage<ChatError_WrongP2PChat> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 6);

/**
 * E_INVALID_CHAT_TYPE
 *
 * @generated from message com.gem.bff.contract.ChatError.InvalidChatType
 */
export type ChatError_InvalidChatType =
  Message<'com.gem.bff.contract.ChatError.InvalidChatType'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.InvalidChatType.
 * Use `create(ChatError_InvalidChatTypeSchema)` to create a new message.
 */
export const ChatError_InvalidChatTypeSchema: GenMessage<ChatError_InvalidChatType> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 7);

/**
 * E_HAS_NO_PERMISSIONS_TO_PERFORM_ACTION
 *
 * @generated from message com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction
 */
export type ChatError_HasNoPermissionsToPerformAction =
  Message<'com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction.
 * Use `create(ChatError_HasNoPermissionsToPerformActionSchema)` to create a new message.
 */
export const ChatError_HasNoPermissionsToPerformActionSchema: GenMessage<ChatError_HasNoPermissionsToPerformAction> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 8);

/**
 * E_USER_CHAT_RELATIONSHIP_DOES_NOT_EXIST
 *
 * @generated from message com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist
 */
export type ChatError_UserChatRelationshipDoesNotExist =
  Message<'com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist.
 * Use `create(ChatError_UserChatRelationshipDoesNotExistSchema)` to create a new message.
 */
export const ChatError_UserChatRelationshipDoesNotExistSchema: GenMessage<ChatError_UserChatRelationshipDoesNotExist> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 9);

/**
 * E_UNSUPPORTED_CHAT_TYPE
 *
 * @generated from message com.gem.bff.contract.ChatError.UnsupportedChatType
 */
export type ChatError_UnsupportedChatType =
  Message<'com.gem.bff.contract.ChatError.UnsupportedChatType'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.UnsupportedChatType.
 * Use `create(ChatError_UnsupportedChatTypeSchema)` to create a new message.
 */
export const ChatError_UnsupportedChatTypeSchema: GenMessage<ChatError_UnsupportedChatType> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 10);

/**
 * E_PINNED_GROUPS_LIMIT
 *
 * @generated from message com.gem.bff.contract.ChatError.PinnedGroupsLimit
 */
export type ChatError_PinnedGroupsLimit =
  Message<'com.gem.bff.contract.ChatError.PinnedGroupsLimit'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.PinnedGroupsLimit.
 * Use `create(ChatError_PinnedGroupsLimitSchema)` to create a new message.
 */
export const ChatError_PinnedGroupsLimitSchema: GenMessage<ChatError_PinnedGroupsLimit> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 11);

/**
 * E_PINNED_CHANNELS_LIMIT
 *
 * @generated from message com.gem.bff.contract.ChatError.PinnedChannelsLimit
 */
export type ChatError_PinnedChannelsLimit =
  Message<'com.gem.bff.contract.ChatError.PinnedChannelsLimit'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.PinnedChannelsLimit.
 * Use `create(ChatError_PinnedChannelsLimitSchema)` to create a new message.
 */
export const ChatError_PinnedChannelsLimitSchema: GenMessage<ChatError_PinnedChannelsLimit> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 12);

/**
 * E_NO_PERMISSIONS_TO_DELETE_MESSAGE
 *
 * @generated from message com.gem.bff.contract.ChatError.NoPermissionsToDeleteMessage
 */
export type ChatError_NoPermissionsToDeleteMessage =
  Message<'com.gem.bff.contract.ChatError.NoPermissionsToDeleteMessage'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.NoPermissionsToDeleteMessage.
 * Use `create(ChatError_NoPermissionsToDeleteMessageSchema)` to create a new message.
 */
export const ChatError_NoPermissionsToDeleteMessageSchema: GenMessage<ChatError_NoPermissionsToDeleteMessage> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 13);

/**
 * E_NO_PERMISSIONS_TO_SEND_MESSAGE
 *
 * @generated from message com.gem.bff.contract.ChatError.NoPermissionsToSendMessage
 */
export type ChatError_NoPermissionsToSendMessage =
  Message<'com.gem.bff.contract.ChatError.NoPermissionsToSendMessage'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.NoPermissionsToSendMessage.
 * Use `create(ChatError_NoPermissionsToSendMessageSchema)` to create a new message.
 */
export const ChatError_NoPermissionsToSendMessageSchema: GenMessage<ChatError_NoPermissionsToSendMessage> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 14);

/**
 * E_MESSAGE_DOESNT_EXIST
 *
 * @generated from message com.gem.bff.contract.ChatError.MessageDoesNotExist
 */
export type ChatError_MessageDoesNotExist =
  Message<'com.gem.bff.contract.ChatError.MessageDoesNotExist'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.MessageDoesNotExist.
 * Use `create(ChatError_MessageDoesNotExistSchema)` to create a new message.
 */
export const ChatError_MessageDoesNotExistSchema: GenMessage<ChatError_MessageDoesNotExist> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 15);

/**
 * E_ARTICLE_IS_NOT_ALLOWED
 *
 * @generated from message com.gem.bff.contract.ChatError.ArticleIsNotAllowed
 */
export type ChatError_ArticleIsNotAllowed =
  Message<'com.gem.bff.contract.ChatError.ArticleIsNotAllowed'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.ArticleIsNotAllowed.
 * Use `create(ChatError_ArticleIsNotAllowedSchema)` to create a new message.
 */
export const ChatError_ArticleIsNotAllowedSchema: GenMessage<ChatError_ArticleIsNotAllowed> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 16);

/**
 * E_COMMIT_SYNC_REQUIRED
 *
 * @generated from message com.gem.bff.contract.ChatError.E2eeCommitSyncRequired
 */
export type ChatError_E2eeCommitSyncRequired =
  Message<'com.gem.bff.contract.ChatError.E2eeCommitSyncRequired'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.E2eeCommitSyncRequired.
 * Use `create(ChatError_E2eeCommitSyncRequiredSchema)` to create a new message.
 */
export const ChatError_E2eeCommitSyncRequiredSchema: GenMessage<ChatError_E2eeCommitSyncRequired> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 17);

/**
 * E_COMMIT_RESYNC_REQUIRED
 *
 * @generated from message com.gem.bff.contract.ChatError.E2eeCommitResyncRequired
 */
export type ChatError_E2eeCommitResyncRequired =
  Message<'com.gem.bff.contract.ChatError.E2eeCommitResyncRequired'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.E2eeCommitResyncRequired.
 * Use `create(ChatError_E2eeCommitResyncRequiredSchema)` to create a new message.
 */
export const ChatError_E2eeCommitResyncRequiredSchema: GenMessage<ChatError_E2eeCommitResyncRequired> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 18);

/**
 * E_E2EE_PARTICIPANT_MISSING_WELCOME
 *
 * @generated from message com.gem.bff.contract.ChatError.E2eeParticipantMissingWelcome
 */
export type ChatError_E2eeParticipantMissingWelcome =
  Message<'com.gem.bff.contract.ChatError.E2eeParticipantMissingWelcome'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatError.E2eeParticipantMissingWelcome.
 * Use `create(ChatError_E2eeParticipantMissingWelcomeSchema)` to create a new message.
 */
export const ChatError_E2eeParticipantMissingWelcomeSchema: GenMessage<ChatError_E2eeParticipantMissingWelcome> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_errors, 0, 19);
